import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  deleteCarBookmark as onDeleteCarBookmark
} from './../../actions/deleteCarBookmarkActions'

const mapStateToProps = (state) => ({
  dataStateDeleteCarBookmark: state.deleteCarBookmark.dataState,
  errorsDeleteCarBookmark: get(state, ['deleteCarBookmark', 'errors', 'data', null])
})

const mapDispatchToProps = {
  onDeleteCarBookmark
}

const withDeleteCarBookmark = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withDeleteCarBookmark }